Intl = require 'intl'
{ locales } = require 'db/locale-information'

formatter = null
module.exports = (num) ->
  formatter ?= new Intl.NumberFormat(locales[0])
  formatter.format(num)



// WEBPACK FOOTER //
// ./app/scripts/lib/format/number.coffee